import { render, staticRenderFns } from "./ModuleHome.vue?vue&type=template&id=03e365e5&"
import script from "./ModuleHome.vue?vue&type=script&lang=js&"
export * from "./ModuleHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports